import Glide from "@glidejs/glide"

class SiteSlider {
  constructor() {
    if(document.querySelector("#glide1")) {
      var destopslide = new Glide("#glide1", {
        type: 'carousel',
        perView: 1,
        autoplay: 5000,
        transitionType: 'fade',
      })
      destopslide.mount()
    }

    if(document.querySelector("#glide2")) {
      var topmenudestop = new Glide("#glide2", {
        type: 'slider',
        startAt: 0,
        hoverpause: false,
        perView: 8
      })
      topmenudestop.mount()
    }

    if(document.querySelector("#glide3")) {
      var topmenumobile = new Glide("#glide3", {
        type: 'carousel',
        startAt: 0,
        autoplay: 3000,
        hoverpause: true,
        perView: 6,
        breakpoints: {
          700: {
            perView: 5
          }
        }
      })
      topmenumobile.mount()
    }


  }
}

export default SiteSlider